import gql from 'graphql-tag'
export default gql `
    query getLastQA($limit: Int, $nextToken: String, $thread: String!, $filter: QAMessagesFilterInput){
        getLastQA(
            limit: $limit,
            nextToken: $nextToken,
            thread: $thread,
            filter: $filter
        ){
            items{
                id
                body
                sender
                sender_name
                sender_id
                read
                created
                updated
                ts
                thread
                status
            },
            nextToken
        }
    }
`